import React, { useState } from 'react';
import { Col, Input, Row } from 'reactstrap';
import EuroUtility from '../../../blocks/utils/euro-utility';
import Ddl from '../../../models/common/Ddl';

interface Props {
    name: any;
    options: Ddl[];
    value?: number;
    maxOtherAmount: number;
    onChanged?: (name: any, id: number) => void;
    isDisabled?: (id: number) => boolean;
}

const PrometBoxListSelect = (props: Props) => {
    const [otherAmount, setOtherAmount] = useState<string>('');

    const isActive = (id: number) => {
        return props.value === id;
    }

    const isDisabled = (id: number): boolean => {
        if (!props.isDisabled)
            return false;

        return props.isDisabled(id);
    }

    const onChanged = (id: number) => {
        if (id === props.value || isDisabled(id))
            return;

        if (props.onChanged) {
            props.onChanged(props.name, id);
        }
    }

    const onOtherAmountChanged = (e: any) => {
        const value = e.target.value;
        const amount = Number(value);

        setOtherAmount(value);

        if (!value || Number.isNaN(amount))
            return;

        onChanged(amount);
    }

    const getOptionClassName = (id: number): string => {
        return `promet-box-list-select-option${isActive(id) ? ' promet-box-list-select-option-selected' : ''}${isDisabled(id) ? ' promet-box-list-select-option-disabled' : ''}`;
    }

    return (
        <Row className='promet-box-list-select-row'>
            {
                props.options.map(value => (
                    <Col key={value.id} xl={2} lg={4} xs={4} className='promet-box-list-select-column'>
                        <div className={getOptionClassName(value.id)} onClick={() => onChanged(value.id)}>
                            <div style={{ textAlign: 'center' }}>
                                <div>{value.value}</div>
                                <div className='euro-text'>{value.secondaryValue}</div>
                            </div>
                        </div>
                    </Col>
                ))
            }
            <Col xl={2} lg={4} xs={4} className='promet-box-list-select-column'>
                <div className={getOptionClassName(otherAmount ? Number(otherAmount) : -1)}>
                    <div style={{ textAlign: 'center' }}>
                        <div className='input-group'>
                            <Input type="text"  value={otherAmount} maxLength={2} name="custom-amount" className='promet-box-list-select-option-other'  onChange={onOtherAmountChanged} />
                            <div className="input-group-append">
                                <span className="input-group-text" id="basic-addon2">EUR</span>
                            </div>
                        </div>
                        {
                            otherAmount &&
                            <div className='euro-text'>({EuroUtility.convert(Number(otherAmount))} HRK)</div>
                        }
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default PrometBoxListSelect;
